import { useEffect, useState } from 'react';
import { Divider, Flex, Descriptions, Space } from 'antd';
import { deleteCustomerCenterFaqAPI, getCustomerCenterFaqDetailAPI } from 'api/customer-center';
import { IconDown, IconPaperClip, IconUp } from 'components/assets/icons';
import { BaseContainer } from 'components/containers';
import { DataGrid, DeleteButton, EditButton, ListButton, NewTag } from 'components/elements';
import { customerCenterFaqTypeOptions } from 'data/options';
import dayjs from 'dayjs';
import { Attachment } from 'pages/common';
import { getFormatDate, objToLowerCase } from 'utils/utils';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { URL_ADMIN } from 'routes/AdminRoute';
import { URL_CUSTOMER_CENTER_FAQ, URL_CUSTOMER_CENTER_FAQ_DETAIL, URL_CUSTOMER_CENTER_FAQ_EDIT, URL_CUSTOMER_CENTER_PRODUCT_FAQ } from 'routes/CommonRoute';

export default function CustomerCenterFaqDetail() {
  const navigate = useNavigate();
  const { no } = useParams();
  const { state } = useLocation();
  const { product_fg, faq_type } = state;
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState({ main: true, reply: true });

  const fnGetDetail = async () => {
    const param = {
      product_fg,
      faq_type
    };

    await getCustomerCenterFaqDetailAPI(no, param)
      .then((res) => {
        const { data_info } = res?.data;
        setValue({
          ...objToLowerCase(data_info)
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fnDelete = async () => {
    const data = [value?.idx];
    await deleteCustomerCenterFaqAPI(data)
      .then((res) => {
        alert('삭제되었습니다.');
        const url = product_fg === 1 ? `${URL_ADMIN}${URL_CUSTOMER_CENTER_PRODUCT_FAQ}` : `${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ}`;
        navigate(url);
      })
      .catch((err) => {
        console.error(err);
      });
  };


  useEffect(() => {
    if (no && (product_fg === 0 || 1) && faq_type) fnGetDetail();
  }, [no, product_fg, faq_type])

  const titleColumns = [
    {
      key: '1',
      title: (
        <>
          {value?.title}
          {dayjs(value?.regist_date).isSame(dayjs(), 'day') && <NewTag />}
        </>
      ),
      dataIndex: 'faq_type',
      align: 'center',
      width: '25%',
      colSpan: 4,
      render: (text) => <Space>카테고리 : {customerCenterFaqTypeOptions?.find((it) => it?.value === text)?.label}</Space>
    },
    { key: '2', title: '', dataIndex: 'writer', align: 'center', width: '25%', colSpan: 0, render: (text) => <Space>작성자 : {text}</Space> },
    { key: '3', title: '', dataIndex: 'regist_date', align: 'center', width: '25%', colSpan: 0, render: (text) => <Space>등록일 : {getFormatDate(text)}</Space> },
    { key: '4', title: '', dataIndex: 'hits', align: 'center', width: '25%', colSpan: 0, render: (text) => <Space>조회수 : {text}</Space> }
  ];

  const fileColumns = [
    {
      key: '1',
      title: '',
      dataIndex: 'attachment',
      render: (text) => (
        <>
          {open?.main ? <IconUp onClick={() => setOpen({ ...open, main: false })} /> : <IconDown onClick={() => setOpen({ ...open, main: true })} />} 첨부
          {open?.main && (
            <div className="attachment-container">
              <Space direction={'vertical'} size={1}>
                {text?.map((it) => (
                  <Attachment label={`${it?.name}.${it?.type}`} icon={<IconPaperClip />} url={it.url} />
                ))}
              </Space>
            </div>
          )}
        </>
      )
    }
  ];

  const navigateItems = [
    {
      key: '1',
      label: '다음글',
      children: (
        <span className="text-click" onClick={() => navigate(`${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ_DETAIL.replace(':no', value?.next_idx)}`, { state: { productFg: product_fg } })}>
          {value?.next_title}
        </span>
      )
    },
    {
      key: '2',
      label: '이전글',
      children: (
        <span className="text-click" onClick={() => navigate(`${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ_DETAIL.replace(':no', value?.prev_idx)}`, { state: { productFg: product_fg } })}>
          {value?.prev_title}
        </span>
      )
    }
  ];

  return (
    <>
      <BaseContainer>
        <DataGrid columns={titleColumns} data={[value]} />
        {value?.attached_file?.length && <DataGrid showHeader={false} bordered={false} columns={fileColumns} data={[value]} />}

        <div style={{ padding: '2rem 1rem', minHeight: '200px' }} dangerouslySetInnerHTML={{ __html: value?.content }} />

        <Divider className="divider" />
        <Descriptions items={navigateItems} column={1} bordered labelStyle={{ width: '10%', textAlign: 'center' }} contentStyle={{ textAlign: 'left' }} />
        <Divider className="divider" />

        <Flex justify={'end'} gap={3}>
          <DeleteButton onClick={fnDelete} />
          <EditButton onClick={() => navigate(`${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ_EDIT.replace(':no', no)}`, { state: { productFg: product_fg } })} />
          <ListButton
            onClick={() => {
              const url = product_fg === 1 ? `${URL_ADMIN}${URL_CUSTOMER_CENTER_PRODUCT_FAQ}` : `${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ}`;
              navigate(url);
            }}
          />
        </Flex>
      </BaseContainer>
    </>
  );
}
